import { enhancementTypes } from './constants'

/**
 * Returns true when an On Call request uses coded shifts (US On Call) rather than
 * hours-based days. A request is in "code mode" when at least one checked day carries a
 * calculationCode. Both create flows seed calculationCode into selectedDays via
 * getDefaultEnhancementDayCode, so the presence of a code on a checked day is the
 * reliable signal — regardless of whether the days come from Redux state or a fetched
 * EnhancementGetResponse.
 */
export const isCodedOnCall = (
  enhancementType: string | undefined,
  days: { checked: boolean; calculationCode?: string | null }[] | null | undefined
): boolean =>
  enhancementType === enhancementTypes.onCall &&
  !!days?.some(day => day.checked && !!day.calculationCode)
